export enum PhosphorVariant {
  'fill' = 'ph-fill',
  'bold' = 'ph-bold',
  'light' = 'ph-light',
  'regular' = 'ph-regular',
  'thin' = 'ph-thin',
  'duotone' = 'ph-duotone',
}

export function isPhosphorVariant(value: string): value is PhosphorVariant {
  return (
    value === PhosphorVariant.duotone ||
    value === PhosphorVariant.bold ||
    value === PhosphorVariant.fill ||
    value === PhosphorVariant.light ||
    value === PhosphorVariant.regular ||
    value === PhosphorVariant.thin
  );
}

export const PhosphorIconType = 'phosphor';
